import type { GameSettings, PersistedStateV1 } from "../types";

export const defaultSettings: GameSettings = {
  fields: ["name"],
  clues: [],
  scope: { kind: "all" },
  sessionLength: 10,
  appearance: "system",
};

export function createDefaultState(): PersistedStateV1 {
  return {
    version: 1,
    settings: structuredClone(defaultSettings),
    familiarity: {},
    history: [],
    totals: { score: 0, streak: 0 },
    dailySnapshots: [],
  };
}
